import { combineReducers } from 'redux';
import fetchArticles from './newsArticles';
import fetchRelatedArticles from './similarNewsArticles';
import fetchFacetDetail from './facetDetail';
import authentication from './authentication';
import title from './title';
import userFeedback from './userFeedback';
import feedbackMessage from './setUserFeedback';

export default combineReducers({
    fetchArticles,
    fetchRelatedArticles,
    fetchFacetDetail,
    title,
    authentication,
    feedbackMessage,
    userFeedback
});


// WEBPACK FOOTER //
// ./src/reducers/index.js